var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    'label-tag',
    _vm.variant === 'default' ? 'label-tag--default' : 'label-tag--textOnly',
    _vm.className
  ],style:(_vm.variant === 'default' ? `border: 1.5px solid ${_vm.color};` : '')},[_c('span',{staticClass:"label-tag__text",style:(`color: ${_vm.color};`)},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }